import React from "react";
import { Link } from "react-router-dom";

const Banner = () => {
  return (
    <>
      <section className="GetHero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-6 mb-5 mb-lg-0">
              <div className="heading">
                <h1 className="mb-5" data-aos="slide-up">
                  Your Gateway To Unlocking The <span>Global Remote Jobs</span>{" "}
                  Opportunity At A Global Pay Scale
                </h1>
                <p data-aos="slide-up">
                  Apply for a remote job from the comfort of your couch.
                </p>
                <p className="mb-5" data-aos="slide-up">
                  Get hired full-time & unleash a good pay scale and career
                  growth.
                </p>
                <Link
                  to="/GetHireDeveloper"
                  className="btn"
                  data-aos="slide-up"
                >
                  <span>Apply Now</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
